import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumb reutilizable en todo el ecosistema.
 * @param {{ items: Array<{ label: string, to?: string }> }} props
 * items sin `to` se rendarizan como texto (nodo actual).
 */
export function Breadcrumb({ items = [], testid = "breadcrumb" }) {
  if (!items.length) return null;
  return (
    <nav
      className="flex items-center text-sm text-slate-500"
      aria-label="Migas de pan"
      data-testid={testid}
    >
      <ol className="flex items-center flex-wrap gap-1">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={item.to || item.label || idx} className="flex items-center">
              {idx > 0 && (
                <ChevronRight size={14} className="mx-1 text-slate-300" aria-hidden />
              )}
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="hover:text-brand-blue transition-colors"
                  data-testid={`${testid}-item-${idx}`}
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  aria-current={isLast ? "page" : undefined}
                  className={isLast ? "text-slate-800 font-medium" : ""}
                  data-testid={`${testid}-item-${idx}`}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
